import {
  Card,
  CardContent,
  CardProps,
  Typography,
  styled,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import ReactQRCode, { QRCodeProps as ReactQRCodeProps } from "react-qr-code"

import { useTranslation } from "providers/i18n"

const StyledReactQRCode = styled(ReactQRCode)(() => ({}))

export interface QRCodeProps extends CardProps {
  url: string
  caption?: string
  secondaryCaption?: string
  reactQRCodeProps?: Omit<ReactQRCodeProps, "value" | "ref">
  endAdornment?: React.ReactElement
}

export const QRCode: React.FC<QRCodeProps> = ({
  url = "",
  caption,
  secondaryCaption,
  sx,
  reactQRCodeProps = {},
  endAdornment,
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppQRCode`]?.styleOverrides || {}
  const { root, qrCodeContent, qrCodeCaption, qrCode, qrCodeSecondaryCaption } =
    styleOverrides

  const { t } = useTranslation()

  return (
    <Card className="AppQRCode-root" sx={deepmerge(root, sx)} {...props}>
      <CardContent className="AppQRCode-content" sx={qrCodeContent}>
        <StyledReactQRCode
          className="AppQRCode-qrcode"
          {...reactQRCodeProps}
          sx={qrCode}
          value={url}
        />
      </CardContent>
      {caption && (
        <Typography
          className="AppQRCode-caption"
          sx={qrCodeCaption}
          variant="caption"
        >
          {t(caption)}
        </Typography>
      )}
      {secondaryCaption && (
        <Typography
          className="AppQRCode-secondary-caption"
          sx={qrCodeSecondaryCaption}
          variant="caption"
        >
          {t(secondaryCaption)}
        </Typography>
      )}
      {endAdornment}
    </Card>
  )
}
